export default __webpack_public_path__ + "img/main.custom.4edc4c14.png";